import { useState, useEffect, useCallback } from 'react';
import { Account } from '../types';
import http from '../services/http';

// Module-scoped pending promise to deduplicate concurrent requests (helps in StrictMode)
let pendingAccountsRequest: Promise<Account[] | null> | null = null;

export const useAccounts = () => {
  const [accounts, setAccounts] = useState<Account[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchAccounts = useCallback(async () => {
    setLoading(true);
    try {
      if (!pendingAccountsRequest) {
        pendingAccountsRequest = (async () => {
          const res = await http.get('/accounts/');
          return res.data as Account[];
        })();
      }

      const data = await pendingAccountsRequest;
      pendingAccountsRequest = null;

      if (data) setAccounts(data as Account[]);
      setLoading(false);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to fetch accounts'));
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAccounts();
  }, [fetchAccounts]);

  return { accounts, loading, error };
};
